import { render, staticRenderFns } from "./BdrTasks.vue?vue&type=template&id=58e87b04"
import script from "./BdrTasks.vue?vue&type=script&lang=js"
export * from "./BdrTasks.vue?vue&type=script&lang=js"
import style0 from "./BdrTasks.vue?vue&type=style&index=0&id=58e87b04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports